<template>
  <b-card>
    <b-row
      align-h="end"
      class="align-items-center mb-1 mr-0"
      style="gap: 1rem;"
    >
      <atualizar-em-lote
        tipo-rotina="DCTFWeb"
        titulo-cabecalho="Atualização de DCTFWeb por Empresa e Período de apuração"
        subtitulo-cabecalho="Selecione as empresas e período de apuração que deseja atualizar"
        titulo="Selecione a(s) empresa(s) que deseja atualizar a DCTFWeb"
        subtitulo="As empresas listadas abaixo possuem a configuração da DCTFWeb marcada no cadastro de empresas em 'Configuração de rotinas e-Cac'"
        :tool-tip="abilityUpdate ? 'A atualização será feita para o Período de apuração informado e para as empresas selecionadas. Cada atualização consumirá um crédito do saldo em conta.' : 'Usuário não possui permissão'"
        :api="apiDctfWeb"
        :disabled="!abilityUpdate"
        alterar-style="font-size: 11.5px; height: 32px; display: inline-flex; align-items: center;"
        :filtros-rapidos="filtrosRapidos"
        :tem-filtro-rapido="true"
        @atualizar-grid="atualizarGrid()"
      />
      <download-em-excel
        class="mx-1"
        :filtro="filtroAtual"
        tipo="DCTFWeb"
        :api="apiDctfWeb"
        :get-info-extra="montarDto"
      />
      <b-dropdown
        variant="outline-primary"
        size="sm"
        class="dropdown-dctfweb"
        style="white-space: nowrap;"
        toggle-class="d-inline-flex align-items-center"
        right
      >
        <template #button-content>
          <feather-icon
            icon="DownloadIcon"
            size="15"
          />
          <span class="ml-50">Baixar Declarações DctfWeb</span>
        </template>
        <b-dropdown-item
          v-for="opcao in opcoesBaixaEmLote"
          :key="opcao"
          @click="baixarEmLote(opcao)"
        >
          {{ opcao }}
        </b-dropdown-item>
      </b-dropdown>
    </b-row>
    <declaracao-list
      ref="dctfWebList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :mostrar-acoes-padrao="true"
      :filtros-rapidos="filtrosRapidos"
      :tem-filtro-extra="true"
      :tem-limpar-filtros="true"
      @limpar-filtros="limparFiltro"
    >
      <template
        slot="filtro-extra"
      >
        <b-row>
          <b-col cols="4">
            <b-form-select
              v-model="mensal"
              @input="mudarFiltroData($event? filtroCustomData : filtroCustomAno )"
            >
              <b-form-select-option :value="true">
                Mensal
              </b-form-select-option>
              <b-form-select-option :value="false">
                Anual
              </b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col cols="8">
            <b-form-input
              v-if="mensal"
              v-model="filtroCustomData"
              type="month"
              @change="mudarFiltroData($event)"
            />
            <b-select
              v-else
              v-model="filtroCustomAno"
              name="filtroSelecao"
              class="search-items"
              :options="anos"
              @input="mudarFiltroData($event)"
            />
          </b-col>
        </b-row>
      </template>
      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <b-badge
          v-if="props.column.field === 'situacao'"
          :variant="getColorTag(props.row[props.column.field])"
        >
          <div :style="props.row[props.column.field].length > 26 ? 'width: 180px; white-space: normal;' : 'max-width: 180px;'">
            {{ props.row[props.column.field] }}
          </div>
        </b-badge>
        <div v-else-if="props.column.field === 'transmissao'">
          {{ props.row[props.column.field] }}
        </div>
      </template>
      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <b-badge
          v-if="props.column.field === 'situacao'"
          :variant="getColorTag(props.row[props.column.field])"
        >
          <div :style="props.row[props.column.field].length > 26 ? 'width: 180px; white-space: normal;' : 'max-width: 180px;'">
            {{ props.row[props.column.field] }}
          </div>
        </b-badge>
        <div v-else-if="props.column.field === 'transmissao'">
          {{ props.row[props.column.field] }}
        </div>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props} "
      >
        <acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          @atualizar-grid="atualizarGrid()"
        />
      </template>
    </declaracao-list>
  </b-card>
</template>

<style lang="scss">

.col-valores{
  white-space: nowrap;
}
.dropdown-dctfweb .dropdown-toggle {
  height: 32px !important;
  display: inline-flex !important;
  align-items: center !important;
}
</style>

<script>
import moment from 'moment'
import DataUtils from '@/@pilar/utils/dataUtils'
import { getUserInfo, abilityValidation } from '@/auth/utils'
import envioHistoricoApi from '@app/shared/services/envio-historico-api'
import api from './shared/services/api'

export default {
  name: 'DeclaracaoDctfWebView',
  components: {
    DeclaracaoList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    Acoes: () => import('./shared/components/acoes/Acoes.vue'),
    AtualizarEmLote: () => import('../shared/components/atualizacao-em-lote/AtualizacaoEmLote.vue'),
    DownloadEmExcel: () => import('@app/download-excel/DownloadEmExcel.vue'),
  },
  data() {
    return {
      abilityUpdate: abilityValidation(2, 3),
      apiDctfWeb: api,
      botoesOption: null,
      linha: null,
      mensal: true,
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social',
        acaoClass: 'col-td-acao-3',
        disabledCheckbox: true,
        colunas: [
          { label: 'Razão social', field: 'razaoSocial', tdClass: 'col-tamanho-cnpj' },
          { label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'col-tamanho-cnpj' },
          { label: 'Período apuração', field: 'periodoApuracao' },
          { label: 'Transmissão', field: 'transmissao', type: 'custom' },
          { label: 'Categoria', field: 'categoria' },
          { label: 'Origem', field: 'origem' },
          { label: 'Tipo', field: 'tipo' },
          { label: 'Situação', field: 'situacao', type: 'custom' }, // regular ou irregular
          { label: 'Débito apurado', field: 'debitoApurado', tdClass: 'col-valores' },
          { label: 'Saldo a pagar', field: 'saldoPagar', tdClass: 'col-valores' },
          { label: 'Consultado em', field: 'consultadoEm', tdClass: 'col-valores' },
        ],
      },
      filtroTipoDownload: null,
      filtroCustomData: '',
      filtroCustomAno: '',
      filtros: [],
      filtrosBase: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      filtrosRapidos: [
        {
          id: 'Ativa',
          colunas: ['Situacao'],
          label: 'Ativa',
          valor: '2',
        },
        {
          id: 'Em Andamento',
          colunas: ['Situacao'],
          label: 'Em Andamento',
          valor: '1',
        },
        {
          id: 'Retificada',
          colunas: ['Situacao'],
          label: 'Retificada',
          valor: '3',
        },
        {
          id: 'Excluida',
          colunas: ['Situacao'],
          label: 'Excluida',
          valor: '4',
        },
        {
          id: 'Indevida',
          colunas: ['Situacao'],
          label: 'Indevida',
          valor: '5',
        },
        {
          id: 'Sem transmissão',
          colunas: ['Situacao'],
          label: 'Sem transmissão',
          valor: '6',
        }],
      criando: true,
      aplicando: false,
      filtroAtual: {},
      opcoesBaixaEmLote: ['DARF', 'Recibo', 'Ambos'],
    }
  },
  created() {
    const dataUtils = new DataUtils()
    this.anos = dataUtils.getArrayAnos('2018')

    const mes = moment().subtract(1, 'month').format('yyyy-MM')
    this.mensal = !this.$route.query.filtroAno

    if (this.mensal) {
      this.filtroCustomData = this.$route.query.filtroMes ? this.$route.query.filtroMes : mes
    } else {
      this.filtroCustomAno = this.$route.query.filtroAno
    }

    if (!this.filtroCustomData) {
      this.filtroCustomData = mes
    }

    this.filtros = [...this.filtrosBase, { valor: this.montarValorPeriodo(this.mensal ? this.filtroCustomData : this.filtroCustomAno), colunas: [this.mensal ? 'Competencia' : 'CompetenciaAnual'] }]
    this.visualizacao.evento = this.carregar
  },
  methods: {
    // Sem ano escolhido, "${data}-01" viraria "-01": filtro NÃO vazio, que o backend
    // aplica e zera a grid. Vazio é o valor certo — `PrepararFiltro` descarta filtro sem
    // valor e a grid volta sem recorte de período, que é o que o campo em branco significa.
    // Usado no created e no mudarFiltroData, para as duas montagens não divergirem.
    montarValorPeriodo(data) {
      if (this.mensal) { return data || '' }
      return data ? `${data}-01` : ''
    },
    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return api.getPaginado(pagina, tamanhoPagina, filtro).then(async response => {
        if (response.data && response.data.valores && response.data.valores.length > 0) {
          const ids = response.data.valores.map(i => i.id)
          const tipoRotinaId = 12 // DeclaracaoDcftWeb
          try {
            const statusResp = await envioHistoricoApi.obterStatus(tipoRotinaId, ids)
            const statusMap = {}
            if (statusResp.data) {
              statusResp.data.forEach(s => { statusMap[s.idRegistro] = s })
            }
            response.data.valores.forEach(item => {
              const status = statusMap[item.id]
              if (status) {
                this.$set(item, 'whatsappEnviado', status.whatsappEnviado)
                this.$set(item, 'emailEnviado', status.emailEnviado)
              }
            })
          } catch (err) {
            this.$erro(err)
          }
        }
        return response
      })
    },
    getColorTag(situacao) {
      if (situacao === 'EmAndamento') {
        return 'light-primary'
      }
      if (situacao === 'Ativa') {
        return 'light-success'
      }
      if (situacao === 'Retificada') {
        return 'light-warning'
      }
      if (situacao === 'Excluida') {
        return 'light-danger'
      }
      if (situacao === 'Sem transmissão' || situacao === 'SemTransmissao') {
        return 'light-primary'
      }
      return 'light-secondary'
    },
    baixarEmLote(evt) {
      const data = new Date()
      const nome = `DctfWeb-${getUserInfo().empresa}-${data.getDate()}-${data.getMonth() + 1}-${data.getFullYear()}`
      api.baixaEmLote(this.filtroAtual, nome, evt)
      this.filtroTipoDownload = null
    },
    mudarFiltroData(data) {
      const dataFinal = this.montarValorPeriodo(data)
      const coluna = this.mensal ? ['Competencia'] : ['CompetenciaAnual']
      const filtroData = { valor: dataFinal, colunas: coluna }

      const index = this.$refs.dctfWebList.enviarServidor.filtros.findIndex(where => where.colunas.length === 1 && where.colunas.some(any => filtroData === null || any === (this.mensal ? 'CompetenciaAnual' : 'Competencia')))

      if (index >= 0) {
        this.$refs.dctfWebList.enviarServidor.filtros.splice(index, 1)
      }

      const filtronew = [...this.filtrosBase, filtroData]
      this.filtros = filtronew
      this.$refs.dctfWebList.filtroImutavel = [...filtronew]
      this.$refs.dctfWebList.aplicarFiltroRapido(filtroData, false)
    },
    atualizarGrid() {
      this.$refs.dctfWebList.buscar()
    },
    montarDto() {
      if (this.$refs.dctfWebList) {
        const empresas = this.$refs.dctfWebList.linhaSelecionada
        this.filtroAtual.empresasSelecionadas = !empresas ? [] : empresas
        return this.filtroAtual
      }
      return undefined
    },
    limparFiltro() {
      this.mensal = true
      const mes = moment().subtract(1, 'month').format('yyyy-MM')
      this.filtroCustomData = mes
      this.filtroCustomAno = ''
      this.mudarFiltroData(this.filtroCustomData)
    },
  },
}
</script>
